import api from './api';

export const authService = {
  async login(email, password) {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  async register(email, password) {
    const response = await api.post('/auth/register', { email, password });
    return response.data;
  },

  async validateToken() {
    try {
      const response = await api.get('/profile');
      return { valid: true, user: response.data.user };
    } catch (error) {
      return { valid: false };
    }
  }
};